import { Fragment } from "react";
import { ScrollRestoration, useSearchParams } from "react-router-dom";
import PublicHeader from "../../../components/layouts/PublicHeader";
import { renderNavItem } from "../utils/contentNavBar";
import { FAQ_CONTENT } from "./faqs/faqContent";
import GeneralAccordion from "../../../components/ui/accordions/GeneralAccordion";

function Faq() {
  const [searchParams] = useSearchParams();
  const rawFilter = searchParams.get("filter");

  const path = "/faq";
  const filter = FAQ_CONTENT[rawFilter] ? rawFilter : "users";

  const activeSections = FAQ_CONTENT[filter];

  return (
    <Fragment>
      <ScrollRestoration />
      <PublicHeader title="Frequent Asked Questions" />
      <div id="container">
        <div className="offerings-container">
          <section className="offerings-nav">
            {renderNavItem(path, filter, "users", "For Users")}
            {renderNavItem(path, filter, "experts", "For Experts")}
            {renderNavItem(path, filter, "affiliates", "For Affiliates")}
          </section>
          <section className="offerings-content">
            {activeSections.map((item, index) => (
              <GeneralAccordion key={`${filter}-${index}`} title={item.title}>
                {item.content}
              </GeneralAccordion>
            ))}
          </section>
        </div>
      </div>
    </Fragment>
  );
}

export default Faq;
